import React from "react"
import {StyledRecentSearchContent} from "./components"

const StandardRecentSearchContent = ({props, children}: any) => {
    return <StyledRecentSearchContent {...props}>{children}</StyledRecentSearchContent>
}

export default StandardRecentSearchContent
